<template>
  <div class="is-marginless is-paddingless section section-details" v-if="detailFacture">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3" >
                {{ $t('editionFacture.echeancierUpdateTitle', {code: detailFacture.code})}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a class="button is-cancel btn-modal-annuler " @click="$router.go(-1)">
              {{ $t('editionFacture.actions.revert')}}
            </a>
            <a class="button is-addOrEdit " @click="ouverturePopUp()">
              {{ $t('general.button.sauvegarder')}}
            </a>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.FACTURES.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                          :error="error"
                          :title="'editionClient.problemOccurred'"
                          :withEmplyFields="true"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          @close="error = $event"/>
      <div class="tab">
        <ul>
          <li @click="activeTab = 'AppFactureInformation'"
              :class="{'is-active': activeTab === 'AppFactureInformation'}">
            {{ $t('editionFacture.onglet.facture')}}
          </li>
          <li @click="activeTab = 'AppAchatFacture'"
              :class="{ 'is-active': activeTab === 'AppAchatFacture' }"
              v-if="moduleAchatAASpe">
            {{ $t('editionFacture.onglet.achats') }}
          </li>
          <li @click="activeTab = 'AppInfoGenerales'"
              :class="{'is-active': activeTab === 'AppInfoGenerales'}">
            {{ $t('editionFacture.onglet.info')}}
          </li>
          <li @click="activeTab = 'AppModificationProduit'"
              :class="{'is-active': activeTab === 'AppModificationProduit'}">
            {{ $t('editionFacture.onglet.produits')}}
          </li>
          <b-tooltip v-if="detailFacture.montantTtc === 0"
                     :label="$t('editionFacture.echeancierPaiement.montantTtcZero')">
            <li class="pointer-events-none text-access-no-permission">
              {{ $t('editionFacture.onglet.echeancier')}}
            </li>
          </b-tooltip>
          <li @click="activeTab = 'AppEcheancierPaiement'" v-else
              :class="{'is-active': activeTab === 'AppEcheancierPaiement'}">
            {{ $t('editionFacture.onglet.echeancier')}}
          </li>
          <li :class="[{'is-active': activeTab === 'commissions'}]"
            @click="activeTab = 'commissions'" v-if="modulePresseActive">
            {{ $t('editionCommande.tabs.commissions') }}
          </li>
          <li :class="{'is-active': activeTab === 'AppFactor'}"
              v-if="moduleFactorActive && !isAcompte"
              @click="activeTab = 'AppFactor'">
            {{ $t('editionFacture.onglet.factor') }}
          </li>
        </ul>
      </div>
    </div>
    <div class="columns">
      <component :is="activeTab" :facture="facture"
                 :class="{'column is-12': activeTab === 'AppFactureInformation'}"
                 :factureDetail="detailFacture"
                 :plan-media="detailFacture"
                 :breadcrumb="breadcrumb"
                 :devisCommande="detailFacture"
                 @errorEvent="findError"/>
    </div>
    <b-modal v-model="openPopUpFactor" has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('editionFacture.popUpFactor.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="openPopUpFactor = false"
        @yes="saveFacture">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import { get, updateFactureEnregistrer } from '@/api/facture/index';
import AppBreadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import AppEcheancierPaiement from '@/components/factures/echeancierPaiement';
import AppModificationProduit from '@/components/factures/m_modificationProduitLigneFacture';
import AppFactureInformation from '@/components/factures/factureInformation';
import AppInfoGenerales from '@/components/bodac/facture/edit/factureEnregistre/infoGenerales';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import gestionDateBase from '@/services/general/gestionDateBase';
import validationGeneral from '@/services/validation/validation';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import commissions from '@/components/planMedia/edition/commissions';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import * as devisConf from '@/configuration/devisConf';
import { updateEcheancierPaiement } from '@/api/echeancierPaiement';
import echeancierGeneration from '@/services/facture/generationEcheancier';
import calculDateEcheancier from '@/services/facture/dateDebutEcheancier';
import formatDate from '@/services/general/formatIsoDate';
import messageSucces from '@/services/general/messageSucces';
import getInfoEcheancierPaiement from '@/services/echeancePaiement/getInformationEcheancierPaiement';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { getAll } from '@/api/commande';
import AppAchatFacture from '@/components/devisCommandes/achat/editionAchatDevisCommande';
import { get as getPlanMedia } from '@/api/planMedia';
import AppFactor from '@/components/factures/m_factor';
import popUpPrevention from '@/components/general/popUpPrevention';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { FACTURES } from '@/configuration/permissionsBodacConf';
import { NON_LETTRE } from '@/configuration/lettrageConf';

const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      facture: null,
      detailFacture: null,
      activeTab: 'AppEcheancierPaiement',
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      constantes: {
        FACTURES,
      },
      olTiersFactorId: null,
      openPopUpFactor: false,
      factureSave: null,
    };
  },
  components: {
    AppBreadcrumb,
    AppEcheancierPaiement,
    AppFactureInformation,
    AppModificationProduit,
    errorMsgComponent,
    AppAchatFacture,
    AppInfoGenerales,
    AppFactor,
    commissions,
    popUpPrevention,
    pieceJointeButton,
  },
  computed: {
    ...User.mapGetters({
      site: 'site',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    moduleAchatAASpe() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.achatAASpe.key);
    },
    delaisReglementFacture() {
      return this.parametre(PARAMETRES_KEYS.delaiReglement).find(item => {
        return item.id === this.detailFacture.delaiReglementId;
      });
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeFactures.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeFactures.title'), route: { name: 'l.bodac.factures' }, isActive: false },
        { title: this.$i18n.t('editionFacture.updateTitle', { code: cloneDeep(this.facture.code) }), route: { name: 'm.bodac.factures' }, isActive: true },
      ];
      return output;
    },
    moduleFactorActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleFactor.key);
    },
    isAcompte() {
      return this.facture.sousType === devisConf.SOUS_TYPE_ACOMPTE;
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    findError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationDevisCommande(response,
        this.messages,
        this.isNewDevisCommande,
        devisConf.TYPE_FACTURE);
      validationGeneral(this.$i18n, response, this.champsVide,
        this.messages, this.messagesChampsVide, translate);
      this.error = true;
    },
    async generationEcheancierPaiementSiUneLigneEchancierEtMontantDiff(facture) {
      if (facture.echeancierPaiement.length !== 1
        || (facture.echeancierPaiement[0].etatLettrage
          && facture.echeancierPaiement[0].etatLettrage !== NON_LETTRE)
        || (facture.modeReglementId === this.factureSave.modeReglementId
          && facture.delaiReglementId === this.factureSave.delaiReglementId
          && facture.echeancierPaiement.length === this.factureSave.echeancierPaiement.length)) {
        return;
      }
      const delaiReglement = facture.delaiReglement.estPersonnalisable
        ? facture.delaiReglementDetail : this.delaisReglementFacture.delaiReglementDetail;
      const dateEcheance = calculDateEcheancier(facture.dateDevisCommande, delaiReglement);
      facture.echeancierPaiement = (await echeancierGeneration({
        nombreEcheances: 1,
        datePremiereEcheance: dateEcheance,
        periodicite: devisConf.MOIS,
        montantTotal: facture.montantTtc
          - (facture.montantAcomptesAffectes
            ? facture.montantAcomptesAffectes : 0),
        modeReglementId: facture.modeReglementId,
      })).data.result;
    },
    async sauvegarde() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const payeur = this.detailFacture.intervenants.find((intervenant) => {
          return intervenant.payeur;
        });
        await this.generationEcheancierPaiementSiUneLigneEchancierEtMontantDiff(this.detailFacture);
        const echeanciersPaiement = cloneDeep(this.detailFacture.echeancierPaiement);
        echeanciersPaiement.forEach((echeance) => {
          echeance.tiersId = payeur.tiersId;
          echeance.factureId = this.detailFacture.id;
          echeance.dateEcheance = formatDate(echeance.dateEcheance);
        });
        await updateEcheancierPaiement({
          factureId: this.detailFacture.id,
          echeanciersPaiement: echeanciersPaiement,
        });
        const annonceur = this.detailFacture.intervenants.find(el => el.annonceur);
        const factureModifiee = {
          id: this.detailFacture.id,
          lignesCommande: [],
          modeReglementId: this.detailFacture.modeReglementId,
          delaiReglementId: this.detailFacture.delaiReglementId,
          delaiReglement: this.detailFacture.delaiReglement,
          commercialId: this.detailFacture.commercialId,
          assistantId: this.detailFacture.assistantId,
          commissionCommercial: this.detailFacture.commissionCommercial,
          commentaireInterne: this.detailFacture.commentaireInterne,
          agenceId: this.detailFacture.agenceId,
          theme: this.detailFacture.theme,
          commentaire: this.detailFacture.commentaire,
          tiersFactorId: this.detailFacture.tiersFactorId,
          factorTransmis: this.detailFacture.factorTransmis,
          factorDateTransmission: this.detailFacture.factorDateTransmission,
          nePasRelancer: this.detailFacture.nePasRelancer,
          commissions: this.detailFacture.commissions,
          commentaireFactor: this.detailFacture.commentaireFactor,
          planMediaId: this.detailFacture.planMediaId,
          tags: this.detailFacture.tags,
          applicationTvaAnnonceur: annonceur.applicationTva,
        };
        this.detailFacture.lignesCommande.forEach(l => {
          const sousLignes = l.lignesCommande.map(ssl => {
            return {
              id: ssl.id,
              type: ssl.type,
              produitId: ssl.produitId,
              lignesCommande: [],
              referenceRegroupement: ssl.referenceRegroupement,
              modeReglementId: ssl.modeReglementId,
              dateReglement: formatDate(ssl.dateReglement),
              fournisseurId: ssl.fournisseurId,
            };
          });
          factureModifiee.lignesCommande.push({
            id: l.id,
            type: l.type,
            lignesCommande: sousLignes,
            produitId: l.produitId,
            referenceRegroupement: l.referenceRegroupement,
          });
        });
        await updateFactureEnregistrer(factureModifiee);
        messageSucces(this.$t('echeancierPaiement.modifSuccess'));
        await this.$router.push({
          name: 'c.bodac.factures',
          params: { id: this.$route.params.idFacture },
        });
        return loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.findError(e.response);
          return loadingComponent.close();
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async checkReferencesToCommande(facture) {
      if ((facture.references && facture.references.length > 0)
        || !facture.lignesCommande.some((ligne) => {
          return ligne.commandeId;
        })) return;
      const commandesIds = [...new Set(facture.lignesCommande.map((ligne) => {
        return ligne.commandeId;
      }))];
      const params = {
        query: {
          societeId: facture.societeId,
          ids: commandesIds,
          sens: devisConf.SENS_VENTE,
        },
        maxResultCount: NO_PAGINATION,
      };
      const commandes = (await getAll(params)).data.result.items;
      facture.references = commandes;
    },
    ouverturePopUp() {
      if (this.olTiersFactorId !== null
        && this.olTiersFactorId !== this.detailFacture.tiersFactorId
        && this.detailFacture.factorTransmis) this.openPopUpFactor = true;
      else this.sauvegarde();
    },
    saveFacture() {
      this.openPopUpFactor = false;
      this.sauvegarde();
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Facture' });
      await this.setAttachmentElementId({ id: this.$route.params.idFacture });
      await this.loadParametres([
        PARAMETRES_KEYS.categorieGroupeProduitDeductible,
        PARAMETRES_KEYS.delaiReglement]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleFactor.key,
        PARAMETRES_INTERNE_KEYS.achatAASpe.key,
      ]);
      await this.loadParametreUtilisateur();
      const factureTempo = (await get(this.$route.params.idFacture)).data.result;
      factureTempo.echeancierPaiement = await getInfoEcheancierPaiement(
        factureTempo.echeancierPaiement,
      );
      if (factureTempo.montantTtc === 0) this.activeTab = 'AppFactureInformation';
      if (factureTempo.etat === devisConf.ETAT_ANNULER) {
        await this.checkReferencesToCommande(factureTempo);
      }
      this.facture = detailDevisCommande(factureTempo);
      factureTempo.dateDevisCommande = gestionDateBase(factureTempo.dateDevisCommande);
      factureTempo.factorDateTransmission = gestionDateBase(factureTempo.factorDateTransmission);
      factureTempo.echeancierPaiement.forEach((element) => {
        element.dateEcheance = gestionDateBase(element.dateEcheance);
      });
      this.detailFacture = factureTempo;
      this.factureSave = cloneDeep(this.detailFacture);
      if (this.detailFacture.planMediaId) {
        this.detailFacture.planMedia = (await getPlanMedia(this.detailFacture.planMediaId))
          .data.result;
      }
      this.olTiersFactorId = this.detailFacture.tiersFactorId;
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.detailFacture.code }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
